"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatChunkToBuffer = void 0;
function concatChunkToBuffer(chunk, buffer) {
    if (!Buffer.isBuffer(chunk)) {
        chunk = Buffer.from(chunk);
    }
    return buffer.concat(chunk);
}
exports.concatChunkToBuffer = concatChunkToBuffer;
//# sourceMappingURL=concatChunkToBuffer.js.map